module.exports = __webpack_public_path__ + "img/play.b4a97d74.svg";